<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="normal"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText"
  >
    <template #header>
      <span>导入标签分类</span>
    </template>
    <template #content>
      <gj-upload
        class="upload-btn"
        downloadTemplate
        templateUrl="/crm/tagCategory/exportCategoryTemplate"
        container-type="tagCategoryOperation"
        @uploadAfter="importTagCategory"
      >
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
        :rules="[
          '支持导入格式为xls/xlsx的文件',
          '标签分类名称为必填项',
          '上级分类为选填项；若不填写，则表示作为一级标签分类',
        ]"
      >
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn ,uploadMixin} from "../../../../../minxins";
import { importTagCategory } from "../../../../../api/system";

export default {
  name: "app-tag-group-import-modal",
  mixins: [modalMixIn,uploadMixin],
  data() {
    return {};
  },
  methods: {
    importTagCategory(attId, data, uploadCb) {
      this.importHandleLoading = true;
      importTagCategory(attId)
        .then((res) => {
          this.$gjImportHandle(res, uploadCb)
        }).catch(() => {
            uploadCb('error')
          })
        .complete(() => (this.importHandleLoading = false));
    },
  },
};
</script>

<style scoped>
.upload-btn {
  margin-bottom: 16px;
}
</style>

